import { Loading } from '@affine/component';
import { useAsyncCallback } from '@affine/core/components/hooks/affine-async-hooks';
import { MenuItem } from '@affine/core/modules/app-sidebar/views';
import { useI18n } from '@affine/i18n';
import { getAuthControllerGetAuthQueryKey } from '@docnboard/rest';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { useIsAuthorized } from './api';
import { miroAtom } from './model';
import { MiroLogoIcon } from './ui';
import { signin } from './utils';

export const ImportMiro = () => {
  const t = useI18n();

  const setMiroAtom = useSetAtom(miroAtom);

  const queryClient = useQueryClient();
  const isAuthorizedQuery = useIsAuthorized();

  const onClick = useAsyncCallback(async () => {
    if (!isAuthorizedQuery.data?.data.isAuthorized) {
      signin();
    } else {
      setMiroAtom(prev => ({ ...prev, openModal: true }));
    }
  }, [isAuthorizedQuery.data?.data.isAuthorized, setMiroAtom]);

  useEffect(() => {
    const channel = new BroadcastChannel('miro_auth');
    channel.onmessage = async () => {
      await queryClient.invalidateQueries({
        queryKey: getAuthControllerGetAuthQueryKey(),
      });
    };
    return () => channel.close();
  }, [queryClient]);

  return (
    <MenuItem
      disabled={isAuthorizedQuery.isFetching}
      icon={<MiroLogoIcon />}
      onClick={onClick}
    >
      {isAuthorizedQuery.isFetching ? (
        <div className="flex flex-col items-center">
          <Loading size="1.5rem" />
        </div>
      ) : (
        t['docnboard.miro.import-button']()
      )}
    </MenuItem>
  );
};
